export default __webpack_public_path__ + "static/media/eib.ab18832b.png";